import { notFoundErrorMessage } from '@consumer-frontend/nc-utils';

import { NcErrorPage } from './NcErrorPage';

export const NcNotFoundErrorPage: React.FC = () => (
  <NcErrorPage displaySupportText message={notFoundErrorMessage} />
);
